import { render, staticRenderFns } from "./talk-list.vue?vue&type=template&id=143d8d89&scoped=true"
import script from "./talk-list.vue?vue&type=script&lang=js"
export * from "./talk-list.vue?vue&type=script&lang=js"
import style0 from "./talk-list.vue?vue&type=style&index=0&id=143d8d89&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143d8d89",
  null
  
)

export default component.exports